"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'payment.stripe.info': '请使用下方的 Stripe Elements 完成支付。',
    'payment.stripe.clientSecret': '客户端密钥',
    'payment.stripe.noClientSecret': '没有可用的 Stripe 客户端密钥',
};
